import LinearProgress from "@material-ui/core/LinearProgress/LinearProgress";
import * as React from "react";
import { RouteComponentProps } from "react-router-dom";
import { GlobalSearchResultList } from "../components/global-search-result-list";
import { IAuthContextProps, withAuthContext } from "../components/with-auth-context";
import { GlobalSearchResultModel } from "../model/autogen/GlobalSearchResultModel";
import { SearchRequestFactory } from "../model/autogen/SearchController";
import { UserLevel } from "../model/autogen/UserLevel";

interface IUnPublishedDraftsProps extends RouteComponentProps<any>, IAuthContextProps {

}

interface IUnPublishedDraftsState {
    model: GlobalSearchResultModel | undefined;
}

class UnPublishedDrafts extends React.Component<IUnPublishedDraftsProps, IUnPublishedDraftsState> {
    constructor(props: IUnPublishedDraftsProps) {
        super(props);
        this.state = {
            model: undefined
        };
    }
    async componentDidMount() {
        const model = await this.props.callApi((fetcher) => SearchRequestFactory.findUnpublished(fetcher));
        this.setState({ model });
    }
    public render(): JSX.Element {
        const { model } = this.state;
        if (!model) {
            return <LinearProgress />;
        }

        return <GlobalSearchResultList accordionMode={true} results={model} />
    }
}

export const UnPublishedDraftsPage = withAuthContext(UnPublishedDrafts, UserLevel.Editor);



// WEBPACK FOOTER //
// ./src/pages/unpublished-drafts.tsx